import { render } from "./MAMarketoForm.vue?vue&type=template&id=59f045ae"
import script from "./MAMarketoForm.vue?vue&type=script&lang=ts"
export * from "./MAMarketoForm.vue?vue&type=script&lang=ts"

import "./MAMarketoForm.vue?vue&type=style&index=0&id=59f045ae&lang=scss"
script.render = render

export default script